import css from 'styled-jsx/css';
import { screen, colors } from 'components/styles/variables';
import searchIcon from 'public/static/images/paid_landing/search-icon.svg';
import ReactModal from 'react-modal';

export const styles = css`
  .mobile-text-search-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 4px 0 16px;
    box-shadow: 0px 1px 0px ${colors.G2};
    width: 100vw;
    height: 64px;
  }

  @media (min-width: ${screen.smMin}) {
    .mobile-text-search-container,
    .filters-mobile {
      display: none;
    }
  }

  .filters-mobile {
    box-shadow: 0px 1px 0px ${colors.G2};
  }

  .search-icon {
    height: 26px;
    width: 26px;
    background: url(${searchIcon});
    background-size: cover;
  }
`;

export const modalStyles: ReactModal.Styles = {
  overlay: { zIndex: 999, backgroundColor: 'rgba(0, 0, 0, 0.5)' },
  content: {
    padding: 0,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
